

























import { Vue, Component, Inject } from "vue-property-decorator";
import { IBasketProviderData } from "@/models/providers/baskets";
import { IProvisionProviderData } from "@/models/providers/provisioning";

@Component
export default class ProvisionWarnings extends Vue {
  // Inject

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  @Inject({ from: "provisionProviderData" })
  public readonly $provisionData!: () => IProvisionProviderData;

  // Computed

  public get basketData() {
    return this.$basketData();
  }

  public get provisionWarnings() {
    return this.$provisionData().provisionErrors;
  }

  // Methods

  public configureProductFromError(errorKey) {
    const basketProduct = this.getProduct(errorKey);
    this.$emit("configureProduct", basketProduct);
  }

  public getProductNameFromError(errorKey) {
    const basketProduct = this.getProduct(errorKey);
    if (!basketProduct) return "";
    return `${basketProduct.product_name}${
      basketProduct.service_identifier
        ? `[${basketProduct.service_identifier}]`
        : ""
    }`;
  }

  public getProduct(errorKey) {
    return this.$_.get(
      this.basketData,
      `basket.products[${errorKey.split(".")[1]}]`
    );
  }
}
